export enum ResumptionStatusCodes {
  OPEN = 1,
  AWAITING_APPROVAL,
  AWAITING_APPROVAL_OF_PAYROLL_ADMIN,
  AWAITING_APPROVAL_OF_HEAD_OF_HR,
  RESUMPTION_APPROVED,
  CANCELLED,
  REJECTED,
  AWAITING_APPROVAL_OF_PRO,
  ATTENDANCE_UPDATION,
  TA_MAPPING_PENDING,
  AWAITING_APPROVAL_OF_HR_OFFICER,
}
